module.exports = __webpack_public_path__ + "img/shuang4.3161c6ad.png";